export const parseRecordHpId = (v, options?: {}) => {
	options = { ...{ separator: '-', displaySeperator: '/' }, ...options }

	return v
		.split(options.separator)
		.map((v) => parseInt(v, 10))
		.join(options.displaySeperator)
}
